import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { SITE, NAV } from "@/lib/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#fcf3e6]/95 backdrop-blur-xl shadow-[0_4px_20px_rgba(1,42,45,0.06)] border-b border-[#e2d5c3]/60"
          : "bg-[#fcf3e6]/80 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex items-center justify-between h-20">
        <button
          onClick={() => handleNav("acasa")}
          className="flex items-center gap-3 group"
          data-testid="header-logo-button"
        >
          <span className="flex flex-col leading-tight text-left">
            <span className="font-serif-display text-xl sm:text-2xl text-[#012a2d] tracking-wide">
              Ari<span className="italic text-[#048a93]">Danya</span>
            </span>
            <span className="text-[9px] sm:text-[10px] uppercase tracking-[0.3em] text-[#048a93] font-semibold">
              Pool & Lounge
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => handleNav(n.id)}
              className="text-[#012a2d]/75 hover:text-[#012a2d] text-sm tracking-wide link-underline font-sans-ui"
              data-testid={`nav-${n.id}`}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            className="hidden md:inline-flex items-center gap-2 bg-[#048a93] hover:bg-[#037078] text-white rounded-full px-5 py-2.5 text-sm font-medium transition-all hover:-translate-y-0.5 hover:shadow-xl"
            data-testid="header-call-button"
          >
            <Phone className="h-4 w-4" />
            {SITE.phoneDisplay}
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden p-2 text-[#012a2d]"
            aria-label="Meniu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#fcf3e6] border-t border-[#e2d5c3]/60 ${
          open ? "max-h-[480px]" : "max-h-0"
        }`}
      >
        <div className="flex flex-col px-5 py-4 gap-2">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => handleNav(n.id)}
              className="text-left text-[#012a2d]/85 py-3 border-b border-[#e2d5c3]/60 font-serif-display text-lg"
              data-testid={`mobile-nav-${n.id}`}
            >
              {n.label}
            </button>
          ))}
          <a
            href={SITE.phoneHref}
            className="mt-3 inline-flex items-center justify-center gap-2 bg-[#048a93] text-white rounded-full px-5 py-3 text-sm font-medium"
            data-testid="mobile-call-button"
          >
            <Phone className="h-4 w-4" />
            Sună acum · {SITE.phoneDisplay}
          </a>
        </div>
      </div>
    </header>
  );
}
